import React, { useMemo } from 'react';

import trans from 'common/tools/translations/trans';

import styles from './styles.module.scss';

type Props = {
  entityRelease?: string;
  sponsored?: boolean;
};

const DayCountdown = ({ entityRelease, sponsored }: Props) => {
  const daysRemaining = useMemo(() => {
    if (!entityRelease) return null;

    const releaseDate = new Date(entityRelease).getTime();
    const now = Date.now();
    const remainingTime = releaseDate - now;
    const days = Math.ceil(remainingTime / (1000 * 60 * 60 * 24));
    return days > 0 ? days : 0;
  }, [entityRelease]);

  if (!sponsored || daysRemaining === null || daysRemaining <= 0) return null;

  return (
    <span className={styles.countdown}>
      {trans('search.sponsored.countdown', { day: daysRemaining })}
    </span>
  );
};

export default DayCountdown;
